function cvtToUrlQuery(obj) {
    let ret = '';
    if (typeof obj === 'object' && obj !== null) {
        Object.keys(obj).map(propKey => {
            let val = obj[propKey];
            ret += propKey + '=' + encodeURIComponent(val) + '&'
            return ''
        });

        if (ret.length > 0)
            ret = ret.substr(0, ret.length - 1);
    }
    return ret;
}

export function formRequestEncode(formData) {
    return cvtToUrlQuery({reqData: JSON.stringify(formData)});
}
